import { burgerMenuBreakpoint, Button } from "@hubrise/react-components"
import styled, { css } from "styled-components"

export const StyledToolbar = styled.div`
  padding: 0.5rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0 1rem;
  overflow-x: auto;

  @media (min-width: ${burgerMenuBreakpoint}) {
    padding: 0.5rem 1.5rem;
    overflow-x: revert; // 'auto' breaks the tooltips in the toolbar on desktop
  }
`

const groupCss = css`
  display: flex;
  align-items: center;
  gap: 0.25rem;
`

export const CommandGroup = styled.div`
  ${groupCss}
`

export const SaveGroup = styled.div`
  ${groupCss}
`

export const ToolButton = styled(Button).attrs(({ variant }) => ({
  variant: variant || "emptyOverGray",
}))``
